var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 10.7812C7.61719 10.9219 7.35938 10.9219 7.21875 10.7812L2.71875 6.28125C2.57812 6.14062 2.57812 5.88281 2.71875 5.74219C2.85938 5.60156 3.11719 5.60156 3.25781 5.74219L7.5 9.98438L11.7188 5.74219C11.8594 5.60156 12.1172 5.60156 12.2578 5.74219C12.3984 5.88281 12.3984 6.14062 12.2578 6.28125L7.75781 10.7812Z",
    fill: "#0D2EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.73ed6a79f0b59e1b0e5fd317f65da0d4.svg";
export { ForwardRef as ReactComponent };